import { UseFormReturn } from "react-hook-form";
import { Inputs } from "./useUpsertProductForm";
import { IconType } from "~/assets/icons/iconPaths";
import { PreviewElement } from "~/components/Backroom/Preview";
import { DescriptionStep, descriptionPreviewImages } from "./DescriptionStep";
import { PriceStep, pricePreviewImages } from "./PriceStep";
import { CategoryStep, categoryPreviewImages } from "./CategoryStep";
import { StockStep, stockPreviewImages } from "./StockStep";
import { PhotosStep, photosPreviewImages } from "./PhotosStep";
import { Step } from "~/hooks/useSteps";
import { StrapiProduct } from "~/shared-types";

type OnContinueOptions = {
  action?: "draft" | "publish";
  visibleFields?: Array<keyof Inputs>;
  shouldExitEditing?: boolean;
};

export type FormUpsertProductStepIds =
  | "description"
  | "price"
  | "category"
  | "stock"
  | "photos";

export type CurrentStepProps = {
  stepId: FormUpsertProductStepIds;
  onContinue: (
    stepId: FormUpsertProductStepIds,
    options?: OnContinueOptions
  ) => void;
  isSubmitting?: boolean;
  isEditing?: boolean;
  onStepChange?: (direction: "previous" | "next") => void;
  form: UseFormReturn<Inputs>;
  product?: StrapiProduct;
};

export type SideMenuItem = {
  icon: IconType;
  sideMenuTitle: string;
  preview: PreviewElement[];
  submitButtonEnabled?: boolean;
  CurrentStep: React.FC<CurrentStepProps>;
};

export const getSideMenuItems = (form?: UseFormReturn<Inputs>) =>
  [
    {
      id: "description",
      status: "pending",
      active: true,
      payload: {
        icon: "feather",
        sideMenuTitle: "Beskrivelse",
        preview: descriptionPreviewImages,
        CurrentStep: form
          ? (props: CurrentStepProps) => (
              <DescriptionStep {...props} form={form} />
            )
          : null,
      },
    },
    {
      id: "price",
      status: "pending",
      active: false,
      payload: {
        icon: "sale",
        sideMenuTitle: "Produktdetaljer",
        preview: pricePreviewImages,
        CurrentStep: form
          ? (props: CurrentStepProps) => <PriceStep {...props} form={form} />
          : null,
      },
    },
    {
      id: "category",
      status: "pending",
      active: false,
      payload: {
        icon: "category",
        sideMenuTitle: "Kategorier",
        preview: categoryPreviewImages,
        CurrentStep: form
          ? (props: CurrentStepProps) => <CategoryStep {...props} form={form} />
          : null,
      },
    },
    {
      id: "stock",
      status: "pending",
      active: false,
      payload: {
        icon: "package",
        sideMenuTitle: "Lager",
        preview: stockPreviewImages,
        CurrentStep: form
          ? (props: CurrentStepProps) => <StockStep {...props} form={form} />
          : null,
      },
    },
    {
      id: "photos",
      status: "pending",
      active: false,
      payload: {
        icon: "images",
        sideMenuTitle: "Fotos / Video",
        preview: photosPreviewImages,
        CurrentStep: form
          ? (props: CurrentStepProps) => <PhotosStep {...props} form={form} />
          : null,
      },
    },
  ] as Step<SideMenuItem, FormUpsertProductStepIds>[];
